<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-qrcode`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 23h14V9H9v14zM7 5h18a2 2 0 012 2v18a2 2 0 01-2 2H7a2 2 0 01-2-2V7a2 2 0 012-2zm6 8h6v6h-6v-6zM9 34v5h5v-5H9zm-2-4h9a2 2 0 012 2v9a2 2 0 01-2 2H7a2 2 0 01-2-2v-9a2 2 0 012-2zM34 9v5h5V9h-5zm-2-4h9a2 2 0 012 2v9a2 2 0 01-2 2h-9a2 2 0 01-2-2V7a2 2 0 012-2zm2 29v5h5v-5h-5zm-2-4h9a2 2 0 012 2v9a2 2 0 01-2 2h-9a2 2 0 01-2-2v-9a2 2 0 012-2zm-10 0h4v4h-4v-4zm0 7h4v6h-4v-6zm8-15h4v4h-4v-4zm7 0h6v4h-6v-4z"/></svg>
</template>
<script>

export default {
  name: 'IconQrcode',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
